<template>
  <div>
    <TableImportError v-if="hasErrors" :response-error="listErrors"/>
    <div v-else class="step-container">
      <div class="step">
        <label>Bước 1: Tải xuống file mẫu</label>
        <button class="btn btn-primary w-130" @click="downloadFileExcelExample">
          <i class="el-icon-bottom text-white"></i> Tải xuống
        </button>
      </div>
      <div class="step">
        <label>Bước 2: Tải file excel lên hệ thống</label>
        <div v-if="fileImport" class="file-info">
          <span>{{ fileImport.name }}</span>
          <el-button type="text" @click="removeFile" class="btn-remove">
            <i class="el-icon-delete text-danger"></i>
          </el-button>
        </div>
        <label v-else class="btn btn-warning w-130" for="upload-file">
          <input
              type="file"
              id="upload-file"
              hidden
              @change="handleFileUpload"
              accept=".xlsx, .xls"
          />
          <i class="el-icon-top text-white"></i> Tải lên
        </label>
      </div>
    </div>

    <div class="footer-actions">
      <el-button type="info" style="color: white" @click="isBack ? backToImport() : closeDialog()">
        {{ isBack ? 'Quay lại' : 'Hủy' }}
      </el-button>
      <el-button
          type="success"
          :disabled="disableImport || disabledSubmit()"
          :loading="disableImport"
          style="background: #1BC5BD; color: white; border-color: #1BC5BD;"
          @click="checkImport ? handleImportFileExcel() : handlePreviewImportFileExcel()"
      >
        Xác nhận
      </el-button>
    </div>
  </div>
</template>


<script>
import * as XLSX from "xlsx";
import {
  IMPORT_TAX_INVOICE,
  PREVIEW_IMPORT_TAX_INVOICE
} from "@/core/services/store/tax-invoice/tax-invoice.module";
import TableImportError from "./TableImportError.vue";

export default {
  name: "ImportTaxInvoice",
  components: {TableImportError},
  data() {
    return {
      fileImport: null,
      dataImport: [],
      listErrors: [],
      disableImport: false,
      checkImport: false,
      isBack: false
    };
  },
  computed: {
    hasErrors() {
      return this.listErrors && this.listErrors.length > 0;
    },
  },
  methods: {
    downloadFileExcelExample() {
      const link = document.createElement("a");
      link.href = `${process.env.BASE_URL}excel/File mẫu import khách hàng.xlsx`;
      link.download = "File mẫu import khách hàng.xlsx";
      link.click();
    },

    disabledSubmit() {
      return this.listErrors.filter(item => item.errors.length > 0).length > 0
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.fileImport = file;
        this.parseExcel(file);
      }
    },

    removeFile() {
      this.fileImport = null;
    },

    closeDialog() {
      this.$emit("closeDialog");
    },

    backToImport() {
      this.fileImport = null;
      this.listErrors = [];
      this.disableImport = false;
      this.isBack = false;
      this.checkImport = false;
    },

    parseExcel(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const workbook = XLSX.read(new Uint8Array(e.target.result), {type: "array"});
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const rawData = XLSX.utils.sheet_to_json(sheet, {header: 1});

        if (rawData.length === 0) return;

        const [headers, ...rows] = rawData;
        const columnMap = {
          "Mã hóa đơn": "ma_hoa_don",
          "Tên khách hàng": "ten_khach_hang",
          "Số điện thoại": "so_dien_thoai",
          "Căn cước công dân": "can_cuoc_cong_dan",
          "ID Trung tâm": "id_trung_tam",
          "Số tiền đóng": "so_tien_dong",
          "Địa chỉ": "dia_chi",
          "Email": "email",
        };
        const mappedHeaders = headers.map(h => columnMap[h] || h);

        this.dataImport = rows
            .filter(row => row.length > 0)
            .map(row => {
              const item = {};
              mappedHeaders.forEach((key, i) => item[key] = row[i]);
              return {...item, error: []};
            });
      };
      reader.readAsArrayBuffer(file);
    },

    async handlePreviewImportFileExcel() {
      this.disableImport = true;
      if (!this.fileImport) {
        this.$notify({title: "Thất bại", message: "Chưa có file nào được chọn", type: "error"});
        this.disableImport = false;
        return;
      }
      if (this.dataImport.length === 0) {
        this.$message.warning("Bạn không thể import khi file excel không có bản ghi nào");
        this.disableImport = false;
        return;
      }
      try {
        const res = await this.$store.dispatch(PREVIEW_IMPORT_TAX_INVOICE, this.dataImport);
        const rawErrors = res?.data?.dataImport || [];
        this.checkImport = res.data?.checkImport;
        this.isBack = true;
        this.listErrors = rawErrors.map(item => ({
          code: item.ma_hoa_don,
          name: item.ten_khach_hang,
          phone: item.so_dien_thoai,
          amount: item.so_tien_dong,
          cccd: item.can_cuoc_cong_dan,
          address: item.dia_chi,
          email: item.email,
          center_id: item.id_trung_tam,
          errors: item.error || []
        }));

        if (!this.checkImport) {
          this.$emit("isError");
        }
      } catch (error) {
        this.$message.error("Import thất bại");
      } finally {
        this.disabledSubmit()
        this.disableImport = false;
      }
    },

    async handleImportFileExcel() {
      try {
        const res = await this.$store.dispatch(IMPORT_TAX_INVOICE, this.dataImport);
        if (!res.error) {
          this.$emit("getListTaxInvoice");
          this.$message.success("Import thành công");
        }
      } catch (e) {
        this.$message.error("Import thất bại");
      } finally {
        this.closeDialog();
      }
    }
  }
};
</script>

<style scoped>
.step-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.step {
  display: flex;
  flex-direction: column;
}

.w-130 {
  width: 130px;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.text-white {
  color: white;
}

.text-danger {
  color: red !important;
}
</style>